import sanitizeHtml, { IOptions } from 'sanitize-html';

const sanitize = (dirty: string, options: IOptions = {}) => {
  return sanitizeHtml(dirty, { ...options });
};

export default sanitize;
